module.exports = function () {
    if (typeof Promise !== 'undefined'){
        return Promise; // eslint-disable-line
    }
    return require('promise-polyfill');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jpex-web/src/$$promise.js
// module id = U8M3
// module chunks = 0